// @ts-strict-ignore
import {Component, Input} from "@angular/core";

@Component({
	selector: "sim-three-column-layout",
	templateUrl: "./three-column-layout.component.html",
	styleUrls: ["./three-column-layout.component.scss"],
	standalone: false,
})
export class ThreeColumnLayoutComponent {
	@Input() layoutOptions: {
		mainChildHandleOverflow?: boolean;
	};
}
